export default __webpack_public_path__ + "static/media/streaming.4e187083.png";